<template>
  <div class="form-group">
    <label>Restaurant</label>
    <multiselect
        :options="restaurants"
        v-model="selectedRestaurant"
        :placeholder="placeholder"
        track-by="name"
        label="name"
        :disabled="isRoleUser"
        :max-height="150"
        @input="setSelectedRestaurant"
    >
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {getAllRestaurant} from "../../api/restaurants";
import store from "../../store";
import User from "../../services/User";
export default {
  name: "AllRestaurants",
  props:[
    'updateSelectedRestaurant',
    'placeholder',
    'returnValue',
    'testRestaurantOnly',
    'where',
  ],
  components: {
    Multiselect
  },
  data(){
    return{
      restaurants: [],
      allRestaurants: [],
      selectedRestaurant: '',
    }
  },
  computed: {
    isRoleUser() {
      return this.$store.state.user && this.$store.state.user.userRolesById && this.$store.state.user.userRolesById[0].role.split('_')[1] === 'USER'
    }
  },
  watch: {
    updateSelectedRestaurant: function (value){
      if(value === "") {
        this.selectedRestaurant = value
      }
    },
    testRestaurantOnly: {
      handler(val) {
      if(val === '' || val === false) {
          this.restaurants = [...this.allRestaurants.filter(e=>e.id === 37 || e.id ===40)]
        } else if (val === true) {
          this.restaurants = [...this.allRestaurants.filter(e=>e.id !== 37 && e.id !==40)]
        }
      },
      immediate: false
    },
    where: {
      handler() {},
      immediate: true
    }
  },
  mounted() {
    this.getAllRestaurants();
  },
  methods: {
    getAllRestaurants: async function () {
      User.fetchUserRoles().then(async role => {
        this.loggedInRole = role;
        switch (role) {
          case 'ROLE_ADMIN':
          case 'ROLE_MANAGER':
          case 'ROLE_AGENT': {
            let allRestaurantsResp = await getAllRestaurant();
            if (allRestaurantsResp.data !== null) {
              this.restaurants = allRestaurantsResp.data;
              this.addRemoveTestRestaurants()
            }
            break;
          }
          case 'ROLE_USER':
          case 'ROLE_BRANCH':
            this.selectedRestaurant = this.$store.state.user.restaurant;
            this.restaurants.push({
              id: this.$store.state.user.restaurant.id,
              name: this.$store.state.user.restaurant.name
            });
            this.addRemoveTestRestaurants()
            this.setSelectedRestaurant()
            break;
        }
      });
    },
    setSelectedRestaurant: function () {
      let option = (this.selectedRestaurant !== null) ? this.selectedRestaurant.id : this.returnValue;
      this.$emit('update:selectedRestaurantId', option);
      this.$emit('update:selectedRestaurant', this.selectedRestaurant);
    },
    addRemoveTestRestaurants() {
      if (this.where === 'orders') {
        this.allRestaurants = [...this.restaurants]
        this.restaurants = [...this.restaurants.filter(e=>e.id !== 37 && e.id !==40)]
      }
    }
  }
}
</script>

<style scoped>

</style>